import React from 'react'
import UserData from '../../components/dashboard/UserData'

function UserPage() {
	return (
		<div>
			<UserData />
		</div>
	)
}

export default UserPage
